import { decode } from 'html-entities'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styles from 'srcReact/SearchPage/components/styles.module.scss'
import { useTranslation } from 'react-i18next'
import AnchorLink from 'srcReact/components/common2/AnchorLink'
import Avatar from 'srcReact/components/common2/Avatar'
import Icon from 'srcReact/components/icons/Icon'
import {
  getContentWithHighlightedText,
  getHighlightedSearchContent,
  matchedSearchInterestsInArray
} from 'srcReact/helpers/utils'
import dayjs from 'dayjs'
import { getDateFormat2 } from 'srcReact/helpers/datetimeHelper'

const Posts = ({ id, scope, isMobile, isNative, isHeader = false, infiniteScrollRef, isBackNavigation }) => {
  const { t } = useTranslation()

  const {
    globalSearch: {
      searchInterestText,
      posts: { results, users, newsfeeds }
    }
  } = useSelector((state) => state)

  const iconSize = isHeader || isMobile ? 'medium' : 'large24'

  let searchedPosts = results
  if (scope === 'all') {
    searchedPosts = results.filter((p) => p.id === id)
  }

  return (
    <div className={styles.searchContentWrapper}>
      {searchedPosts?.length > 0 &&
        searchedPosts.map((p, i) => {
          // const path = p.url.replace(/.*\/\/[^\/]*/, '')
          const newsfeed = newsfeeds.find((n) => n.id === p.newsfeed_id)
          const user = users.find((u) => u.id === p.user_id)

          return (
            <AnchorLink
              path={p.url}
              isReactLink={false}
              className={`${styles.searchContent} ${(isHeader || isMobile) && styles.headerContentWrapper}`}
              key={i}
              ref={infiniteScrollRef}
              onMouseDown={(e) => e.preventDefault()}>
              <div className={`${styles.picture} ${styles.isPosts}`}>
                <Icon name='discussion24' size={iconSize} />
                <Avatar
                  imgWrapperSize='small48'
                  focusable={false}
                  userId={user?.id}
                  profilePicture={user?.profile_picture}
                  firstname={user?.firstname}
                  lastname={user?.lastname}
                  mimeType={user?.mime_type}
                  originalTag={user?.original_tag}
                  isOriginal={user?.is_original}
                  showImageAsDecorative={true}
                  withExpertiseGroup={user?.with_expertise_group}
                />
              </div>
              <div className={styles.heading}>
                <div className={styles.titleInterests}>
                  <div className={styles.username}>{user?.firstname + ' ' + user?.lastname}</div>
                </div>
                <div
                  className={styles.title}
                  dangerouslySetInnerHTML={{
                    __html: getContentWithHighlightedText(`${decode(p.content?.message)}`, searchInterestText)
                  }}
                />

                <div
                  dangerouslySetInnerHTML={{
                    __html: getHighlightedSearchContent(
                      `${decode(p.content?.message)}`,
                      matchedSearchInterestsInArray(p.interests, searchInterestText)
                    )
                  }}
                />
              </div>
              {!isHeader && !isMobile && (
                <div className={styles.rightContent}>
                  <div className={styles.datetime}>
                    <Icon name='calendar24' size={iconSize} styleModifier={styles.customIcon} />
                    {dayjs(p.content?.createdAt).format(getDateFormat2())}
                  </div>
                  <div className={styles.groupName}>
                    <Icon name='groups24' size={iconSize} styleModifier={styles.customIcon} />
                    {decode(newsfeed?.name)}
                  </div>
                </div>
              )}
            </AnchorLink>
          )
        })}
    </div>
  )
}

export default Posts
